import { toast } from 'sonner'
import { BUILD_VERSION } from './build-info'

const STALE_KEY = 'version-stale-notified'

async function checkForStaleVersion(): Promise<{ isStale: boolean; local: string; remote: string | null }> {
  try {
    const res = await fetch('/version.json', { cache: 'no-store' })
    if (!res.ok) return { isStale: false, local: BUILD_VERSION, remote: null }
    const data: { version?: string } = await res.json()
    const remote = data.version ?? null
    return { isStale: remote !== null && remote !== BUILD_VERSION, local: BUILD_VERSION, remote }
  } catch {
    return { isStale: false, local: BUILD_VERSION, remote: null }
  }
}

async function notifyIfStale() {
  if (sessionStorage.getItem(STALE_KEY)) return
  const result = await checkForStaleVersion()
  if (result.isStale) {
    sessionStorage.setItem(STALE_KEY, '1')
    toast('A new version is available', {
      description: 'Please refresh to get the latest updates.',
      duration: Infinity,
      action: {
        label: 'Refresh',
        onClick: () => window.location.reload(),
      },
    })
  }
}

export function startVersionCheck(): () => void {
  sessionStorage.removeItem('chunk-error-reload')

  const initialTimeout = setTimeout(notifyIfStale, 30_000)
  const interval = setInterval(notifyIfStale, 5 * 60 * 1000)

  return () => {
    clearTimeout(initialTimeout)
    clearInterval(interval)
  }
}
